import React, {useState} from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";
import Login from 'dugoly-login'
import Uploader  from 'dugoly-uploader'


import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
  state = {Path:''}
  callback=(p)=>{
    this.setState({Path:p})
    alert("The path to the image is: "+p)
  }
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  // const [Path,setPath]=useState('')
    return (
      <div   >
        <Login  />
      <h1>
        getCredit  <br />
        </h1>
        
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
        uploader
        <br /></h1>
<h2>
To upload an image, you must first log in using dugoly.com, click the log in button above!<br /><br />
After that, upload the image, using the following button:
  <div 
        style={{display: 'flex', justifyContent: 'center'}}
     >
       <div >
       
<Uploader callback={this.callback} onError={(e)=>{alert("Image save error: "+e)}} />
</div></div>
<h1 style={{color:"red"}}> {this.state.Path&&"The path to the image is: "}<a href={this.state.Path} target="blank" > {this.state.Path}</a></h1>
{this.state.Path?<div>Explanation of how to build the link to the collection page:<br/>
<br/>
In order to direct users to a credit information entry page, you must build the link as follows:<br/><br/>
https://getcredit.link/get-credit-card-details/[dugoly_uid]/[client_id]/[amount]/[business_name]/[logo_id]<br/><br/>
Your dugoly_uid is:{this.state.Path.split('/')[this.state.Path.split('/').length-2]}<br/><br/>
Your logo_id is:{this.state.Path.split('/')[this.state.Path.split('/').length-1]}<br/><br/>
The business_name is the name of the business as you want it to appear on the collection page<br/>
The client_id you enter which code you want, this code means the identification of the customer, so that you can identify who the customer who entered the credit card information<br/>
And amount is the transaction amount<br/>
In these 3 parameters (business_name, client_id, amount) you can enter any data you want, but do not leave it blank<br/>
</div>:<h3>An explanation of how to build the link to the collection page will appear here immediately after uploading the image</h3>}


</h2>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/uploader.js